import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';



@Component({
  selector: 'sml-form-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-spinner.component.html',
  styleUrl: './form-spinner.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FormSpinnerComponent {
  @Input() showFormImage?:boolean = false;
}
